import { FileDocIcon, FileHtmlIcon, FileMdIcon, FilePdfIcon, FileTextIcon } from '@phosphor-icons/react'
import { match } from 'ts-pattern'
import { type DocType } from './coding-guidelines-types.ts'

type DocTypeIconProps = {
  docType: DocType | undefined
  size?: number
}

export const DocTypeIcon: React.FC<DocTypeIconProps> = ({ docType, size = 18 }) =>
  match(docType)
    .with('pdf', () => <FilePdfIcon size={size} weight="light" />)
    .with('docx', () => <FileDocIcon size={size} weight="light" />)
    .with('md', () => <FileMdIcon size={size} weight="light" />)
    .with('html', () => <FileHtmlIcon size={size} weight="light" />)
    .otherwise(() => <FileTextIcon size={size} weight="light" />)
